import { createColumnHelper } from "@tanstack/react-table";
import { moneyDisplay, qtyDisplay } from "@icraftx/shared/v1";
import type { DeskTableFeatures } from "@/modules/shell/data-table";

export type ReturnDetailLine = {
  id: string;
  productId: string;
  description: string | null;
  qty: string;
  unitPrice: string;
  lineNet: string;
  lineTax: string;
  lineGross: string;
  lotCode: string | null;
  serialCode: string | null;
};

const lineHelper = createColumnHelper<DeskTableFeatures, ReturnDetailLine>();

export function returnLineColumns() {
  return lineHelper.columns([
    lineHelper.display({
      id: "description",
      header: "Item",
      size: 200,
      cell: ({ row }) => row.original.description ?? "Item",
    }),
    lineHelper.accessor("qty", {
      id: "qty",
      header: "Qty",
      size: 80,
      cell: (info) => (
        <span className="font-mono tabular-nums">
          {qtyDisplay(info.getValue())}
        </span>
      ),
    }),
    lineHelper.accessor("unitPrice", {
      id: "unitPrice",
      header: "Price",
      size: 96,
      meta: { align: "right" },
      cell: (info) => (
        <span className="font-mono tabular-nums">
          {moneyDisplay(info.getValue())}
        </span>
      ),
    }),
    lineHelper.accessor("lotCode", {
      id: "lotCode",
      header: "Lot",
      size: 100,
      cell: (info) => info.getValue() ?? "—",
    }),
    lineHelper.accessor("serialCode", {
      id: "serialCode",
      header: "Serial",
      size: 100,
      cell: (info) => info.getValue() ?? "—",
    }),
    lineHelper.accessor("lineGross", {
      id: "lineGross",
      header: "Gross",
      size: 100,
      meta: { align: "right" },
      cell: (info) => (
        <span className="font-mono tabular-nums">
          {moneyDisplay(info.getValue())}
        </span>
      ),
    }),
  ]);
}
